import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, CadastrarFuncionalidadeRequest } from './types';

// ACTIONS
import {
	cadastrarFuncionalidadeSuccess,
	cadastrarFuncionalidadeFailure,
} from './actions';

function* cadastrarFuncionalidade(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: CadastrarFuncionalidadeRequest } = request;

	const body = { ...payload };

	delete body.idUsuarioAutenticado;

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_SGU_API,
		`funcionalidades`,
		body,
		{ idUsuarioAutenticado: payload.idUsuarioAutenticado },
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastrarFuncionalidadeSuccess(response));
	} else {
		yield put(cadastrarFuncionalidadeFailure());
	}
}

export default all([
	takeLatest(Types.CADASTRAR_FUNCIONALIDADE, cadastrarFuncionalidade),
]);
